<template>
  <v-container fluid class="soft-grey section-height">
    <v-row no-gutters>
      <Header :value="'На какие принципы и ценности я опираюсь:'"/>
    </v-row>
    <v-row>
      <v-col class="mb-10">
        <v-timeline dense>
          <v-timeline-item color="#5d4a3d" icon="mdi-check-all">
            <v-card class="mr-12">
              <v-card-title class="title font-weight-bold">
                Индивидуальный подход к каждому клиенту
              </v-card-title>
              <v-card-text class="font-weight-light">
                Каждый человек уникален, и, казалось бы, один и тот же запрос, с которым клиент обращается к психологу,
                может иметь абсолютно разные причины. Кроме того, в зависимости от личностных особенностей человека
                изменяется и тактика терапии, используемые техники. С моей точки зрения не существует «универсальной
                методики», которая подойдет всем. Поэтому я стараюсь, прежде всего, обращать внимание на личность
                клиента, так как мы всегда больше, чем проблема, которая возникла в нашей жизни.
              </v-card-text>
            </v-card>
          </v-timeline-item>
          <v-timeline-item color="#5d4a3d" icon="mdi-check-all">
            <v-card class="mr-12">
              <v-card-title class="title font-weight-bold">
                Безопасность, комфорт и доверие
              </v-card-title>
              <v-card-text class="font-weight-light">
                <v-col>
                  Доверительные терапевтические отношения являются одним важных факторов эффективности психотерапии. Я
                  убеждена в том, что пока отношения клиента с терапевтом не будут ощущаться как безопасные, не
                  получиться подойти к тому, что лежит глубоко внутри нас, соприкоснуться с болезненным, волнующим.
                </v-col>
                <v-col>
                  В связи с этим я стараюсь уделять много внимания атмосфере контакта, создавая принимающее,
                  безоценочное, поддерживающее пространство, где вы сможете открыто поделиться со мной вашими
                  переживаниями и попробовать найти пути для изменений.
                </v-col>
              </v-card-text>
            </v-card>
          </v-timeline-item>
          <v-timeline-item color="#5d4a3d" icon="mdi-check-all">
            <v-card class="mr-12">
              <v-card-title class="title font-weight-bold">
                Внимание к чувствам, телесным проявлениям
              </v-card-title>
              <v-card-text class="font-weight-light">
                <v-col>
                  Язык тела – первый способ взаимодействия с миром, которому учится ребенок. То, насколько удачным был
                  опыт ранних телесных контактов, удовлетворения потребностей родителями, оказывает влияние на всю нашу
                  последующую жизнь.
                </v-col>
                <v-col>
                  В современном обществе присутствует тенденция отождествлять разум, когнитивную составляющую, и
                  человека. При этом телесные ощущения, эмоции, чувства зачастую отходят на второй план, или совсем
                  игнорируются, а на наше тело мы обращаем внимание только в тех случаях, когда с ним что-то «не так»
                  (болезни, или, например, кажущаясь «внешняя непривлекательность). Часто мы склонны уходить в анализ
                  себя, построение логических объяснений своих действий. В то же время, такой подход не дает нам увидеть
                  себя целиком, во всем богатстве наших проявлений. Но наше тело с его потребностями, симптомами,
                  непонятными ощущениями, чувствами хочет быть услышано.
                </v-col>
                <v-col>
                  В своей работе для меня важно учитывать эту часть опыта, вместе с клиентом попробовать с ним
                  соприкоснуться, увидеть новые грани себя. Иногда здесь открывается очень много ресурсов, которые могут
                  поддержать нас на пути к изменениям.
                </v-col>
              </v-card-text>
            </v-card>
          </v-timeline-item>
          <v-timeline-item color="#5d4a3d" icon="mdi-check-all">
            <v-card class="mr-12">
              <v-card-title class="title font-weight-bold">
                Исследовательская позиция
              </v-card-title>
              <v-card-text class="font-weight-light">
                <v-col>
                  Я, как психолог, обладаю некоторыми знаниями, навыками, профессиональными компетенцими, и, используя
                  их, а также свой жизненный опыт, опыт личной терапии, я могу постараться вам помочь изучить себя,
                  лучше понять, чего вы хотите и как можно к этому прийти.
                </v-col>
                <v-col>
                  В то же время, для меня клиент сам является автором своей жизни, поэтому я стремлюсь не навязывать Вам
                  свои ценности и мое восприятие мира. Я не знаю заранее, что для вас хорошо, а что плохо, на этот
                  вопрос ответить можете только вы сами.
                </v-col>
                <v-col>
                  Подробнее о том, что для меня значит психотерапия, можно почитать
                  <router-link to="/about">здесь</router-link>
                  .
                </v-col>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-col>

      <!--        <div class="text-center pa-5 darken-2&#45;&#45;text col-12">-->
      <!--          &lt;!&ndash;                  <div class="v-sheet theme&#45;&#45;light secondary">&ndash;&gt;-->
      <!--          <div class="container pa-2 ">-->
      <!--            <v-row class="row hidden-sm-and-down">-->

      <!--              <v-col class="col-md-6 col-12">-->
      <!--                <v-card-->
      <!--                  class=""-->
      <!--                  max-width="calc(45vw - 5vw)"-->
      <!--                >-->
      <!--                  <v-img-->
      <!--                    src="../../public/pictures/26.jpg"-->
      <!--                    height="400px"-->
      <!--                  ></v-img>-->

      <!--                  <v-card-title>-->
      <!--                    Индивидуальный подход к каждому клиенту-->
      <!--                  </v-card-title>-->

      <!--                  <v-card-actions>-->
      <!--                    <v-btn-->
      <!--                      color="orange lighten-2"-->
      <!--                      text-->
      <!--                      @click="show = !show"-->

      <!--                    >-->
      <!--                      Подробнее-->
      <!--                    </v-btn>-->

      <!--                    <v-spacer></v-spacer>-->

      <!--                    <v-btn-->
      <!--                      icon-->
      <!--                      @click="show = !show"-->
      <!--                    >-->
      <!--                      <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>-->
      <!--                    </v-btn>-->
      <!--                  </v-card-actions>-->

      <!--                  <v-expand-transition>-->
      <!--                    <div v-show="show">-->
      <!--                      <v-divider></v-divider>-->

      <!--                      <v-card-text>-->
      <!--                        Каждый человек уникален, и, казалось бы, один и тот же запрос, с которым клиент обращается к-->
      <!--                        психологу, может иметь абсолютно разные причины. Кроме того, в зависимости от личностных-->
      <!--                        особенностей человека изменяется и тактика терапии, используемые техники. С моей точки зрения не-->
      <!--                        существует «универсальной методики», которая подойдет всем. Поэтому я стараюсь, прежде всего,-->
      <!--                        обращать внимание на личность клиента, так как мы всегда больше, чем проблема, которая возникла-->
      <!--                        в нашей жизни.-->
      <!--                      </v-card-text>-->
      <!--                    </div>-->
      <!--                  </v-expand-transition>-->
      <!--                </v-card>-->
      <!--              </v-col>-->

      <!--              <v-col>-->
      <!--                <v-card-->
      <!--                  class=""-->
      <!--                  max-width="calc(45vw - 5vw)"-->
      <!--                >-->
      <!--                  <v-img-->
      <!--                    src="../../public/pictures/22.jpg"-->
      <!--                    height="400px"-->
      <!--                  ></v-img>-->

      <!--                  <v-card-title>-->
      <!--                    Безопасность, комфорт и доверие-->
      <!--                  </v-card-title>-->

      <!--                  <v-card-actions>-->
      <!--                    <v-btn-->
      <!--                      color="orange lighten-2"-->
      <!--                      text-->
      <!--                      @click="show2 = !show2"-->

      <!--                    >-->
      <!--                      Подробнее-->
      <!--                    </v-btn>-->

      <!--                    <v-spacer></v-spacer>-->

      <!--                    <v-btn-->
      <!--                      icon-->
      <!--                      @click="show2 = !show2"-->
      <!--                    >-->
      <!--                      <v-icon>{{ show2 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>-->
      <!--                    </v-btn>-->
      <!--                  </v-card-actions>-->

      <!--                  <v-expand-transition>-->
      <!--                    <div v-show="show2">-->
      <!--                      <v-divider></v-divider>-->

      <!--                      <v-card-text>-->
      <!--                        Доверительные терапевтические отношения являются одним важных факторов-->
      <!--                        эффективности психотерапии. Я убеждена в том, что пока отношения клиента-->
      <!--                        с терапевтом не будут ощущаться как безопасные, не получиться подойти к-->
      <!--                        тому, что лежит глубоко внутри нас, соприкоснуться с болезненным,-->
      <!--                        волнующим. В связи с этим я стараюсь уделять много внимания атмосфере-->
      <!--                        контакта, создавая принимающее, безоценочное, поддерживающее-->
      <!--                        пространство, где вы сможете открыто поделиться со мной вашими-->
      <!--                        переживаниями и попробовать найти пути для изменений.-->
      <!--                      </v-card-text>-->
      <!--                    </div>-->
      <!--                  </v-expand-transition>-->
      <!--                </v-card>-->
      <!--              </v-col>-->

      <!--              <v-col>-->
      <!--                <v-card-->
      <!--                  max-width="calc(45vw - 5vw)"-->
      <!--                >-->
      <!--                  <v-img-->
      <!--                    src="../../public/pictures/24.jpg"-->
      <!--                    height="400px"-->
      <!--                  ></v-img>-->

      <!--                  <v-card-title>-->
      <!--                    Внимание к чувствам, телесным проявлениям-->
      <!--                  </v-card-title>-->

      <!--                  <v-card-actions>-->
      <!--                    <v-btn-->
      <!--                      color="orange lighten-2"-->
      <!--                      text-->
      <!--                      @click="show2 = !show2"-->

      <!--                    >-->
      <!--                      Подробнее-->
      <!--                    </v-btn>-->

      <!--                    <v-spacer></v-spacer>-->

      <!--                    <v-btn-->
      <!--                      icon-->
      <!--                      @click="show2 = !show2"-->
      <!--                    >-->
      <!--                      <v-icon>{{ show2 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>-->
      <!--                    </v-btn>-->
      <!--                  </v-card-actions>-->

      <!--                  <v-expand-transition>-->
      <!--                    <div v-show="show2">-->
      <!--                      <v-divider></v-divider>-->

      <!--                      <v-card-text>-->
      <!--                        Язык тела – первый способ взаимодействия с миром, которому учится ребенок. То, насколько удачным-->
      <!--                        был опыт ранних телесных контактов, удовлетворения потребностей родителями, оказывает влияние на-->
      <!--                        всю нашу последующую жизнь. <br/>-->
      <!--                        В современном обществе присутствует тенденция отождествлять разум, когнитивную составляющую, и-->
      <!--                        человека. При этом телесные ощущения, эмоции, чувства зачастую отходят на второй план, или-->
      <!--                        совсем игнорируются, а на наше тело мы обращаем внимание только в тех случаях, когда с ним-->
      <!--                        что-то «не так» (болезни, или, например, кажущаясь «внешняя непривлекательность). Часто мы-->
      <!--                        склонны уходить в анализ себя, построение логических объяснений своих действий. В то же время,-->
      <!--                        такой подход не дает нам увидеть себя целиком, во всем богатстве наших проявлений. Но наше тело-->
      <!--                        с его потребностями, симптомами, непонятными ощущениями, чувствами хочет быть услышано. <br/>-->
      <!--                        В своей работе для меня важно учитывать эту часть опыта, вместе с клиентом попробовать с ним-->
      <!--                        соприкоснуться, увидеть новые грани себя. Иногда здесь открывается очень много ресурсов, которые-->
      <!--                        могут поддержать нас на пути к изменениям.-->
      <!--                      </v-card-text>-->
      <!--                    </div>-->
      <!--                  </v-expand-transition>-->
      <!--                </v-card>-->
      <!--              </v-col>-->

      <!--              <v-col>-->
      <!--                <v-card-->
      <!--                  max-width="calc(45vw - 5vw)"-->
      <!--                >-->
      <!--                  <v-img-->
      <!--                    src="../../public/pictures/25.jpg"-->
      <!--                    height="400px"-->
      <!--                  ></v-img>-->

      <!--                  <v-card-title>-->
      <!--                    Исследовательская позиция-->
      <!--                  </v-card-title>-->

      <!--                  <v-card-actions>-->
      <!--                    <v-btn-->
      <!--                      color="orange lighten-2"-->
      <!--                      text-->
      <!--                      @click="show3 = !show3"-->

      <!--                    >-->
      <!--                      Подробнее-->
      <!--                    </v-btn>-->

      <!--                    <v-spacer></v-spacer>-->

      <!--                    <v-btn-->
      <!--                      icon-->
      <!--                      @click="show3 = !show3"-->
      <!--                    >-->
      <!--                      <v-icon>{{ show3 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>-->
      <!--                    </v-btn>-->
      <!--                  </v-card-actions>-->

      <!--                  <v-expand-transition>-->
      <!--                    <div v-show="show3">-->
      <!--                      <v-divider></v-divider>-->

      <!--                      <v-card-text>-->
      <!--                        Я, как психолог, обладаю некоторыми знаниями, навыками, профессиональными компетенцими, и,-->
      <!--                        используя их, а также свой жизненный опыт, опыт личной терапии, я могу постараться вам помочь-->
      <!--                        изучить себя, лучше понять, чего вы хотите и как можно к этому прийти. <br/>-->
      <!--                        В то же время, для меня клиент сам является автором своей жизни, поэтому я стремлюсь не-->
      <!--                        навязывать Вам свои ценности и мое восприятие мира. Я не знаю заранее, что для вас хорошо, а что-->
      <!--                        плохо, на этот вопрос ответить можете только вы сами. <br/>-->
      <!--                        Подробнее о том, что для меня значит психотерапия, можно почитать-->
      <!--                        <router-link to="/about">здесь</router-link>-->
      <!--                        .-->
      <!--                      </v-card-text>-->
      <!--                    </div>-->
      <!--                  </v-expand-transition>-->
      <!--                </v-card>-->
      <!--              </v-col>-->

      <!--            </v-row>-->

      <!--            <v-row class="row hidden-md-and-up">-->

      <!--              <v-col class="col-md-6 col-12">-->
      <!--                <v-card-->
      <!--                  class=""-->
      <!--                >-->
      <!--                  <v-img-->
      <!--                    src="../../public/pictures/26.jpg"-->
      <!--                    height="400px"-->
      <!--                  ></v-img>-->

      <!--                  <v-card-title>-->
      <!--                    Индивидуальный подход к каждому клиенту-->
      <!--                  </v-card-title>-->

      <!--                  <v-card-actions>-->
      <!--                    <v-btn-->
      <!--                      color="orange lighten-2"-->
      <!--                      text-->
      <!--                      @click="show = !show"-->

      <!--                    >-->
      <!--                      Подробнее-->
      <!--                    </v-btn>-->

      <!--                    <v-spacer></v-spacer>-->

      <!--                    <v-btn-->
      <!--                      icon-->
      <!--                      @click="show = !show"-->
      <!--                    >-->
      <!--                      <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>-->
      <!--                    </v-btn>-->
      <!--                  </v-card-actions>-->

      <!--                  <v-expand-transition>-->
      <!--                    <div v-show="show">-->
      <!--                      <v-divider></v-divider>-->

      <!--                      <v-card-text>-->
      <!--                        Каждый человек уникален, и, казалось бы, один и тот же запрос, с которым клиент обращается к-->
      <!--                        психологу, может иметь абсолютно разные причины. Кроме того, в зависимости от личностных-->
      <!--                        особенностей человека изменяется и тактика терапии, используемые техники. С моей точки зрения не-->
      <!--                        существует «универсальной методики», которая подойдет всем. Поэтому я стараюсь, прежде всего,-->
      <!--                        обращать внимание на личность клиента, так как мы всегда больше, чем проблема, которая возникла-->
      <!--                        в нашей жизни.-->
      <!--                      </v-card-text>-->
      <!--                    </div>-->
      <!--                  </v-expand-transition>-->
      <!--                </v-card>-->
      <!--              </v-col>-->

      <!--              <v-col>-->
      <!--                <v-card-->
      <!--                  class=""-->
      <!--                >-->
      <!--                  <v-img-->
      <!--                    src="../../public/pictures/22.jpg"-->
      <!--                    height="400px"-->
      <!--                  ></v-img>-->

      <!--                  <v-card-title>-->
      <!--                    Безопасность, комфорт и доверие-->
      <!--                  </v-card-title>-->

      <!--                  <v-card-actions>-->
      <!--                    <v-btn-->
      <!--                      color="orange lighten-2"-->
      <!--                      text-->
      <!--                      @click="show2 = !show2"-->

      <!--                    >-->
      <!--                      Подробнее-->
      <!--                    </v-btn>-->

      <!--                    <v-spacer></v-spacer>-->

      <!--                    <v-btn-->
      <!--                      icon-->
      <!--                      @click="show2 = !show2"-->
      <!--                    >-->
      <!--                      <v-icon>{{ show2 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>-->
      <!--                    </v-btn>-->
      <!--                  </v-card-actions>-->

      <!--                  <v-expand-transition>-->
      <!--                    <div v-show="show2">-->
      <!--                      <v-divider></v-divider>-->

      <!--                      <v-card-text>-->
      <!--                        Доверительные терапевтические отношения являются одним важных факторов-->
      <!--                        эффективности психотерапии. Я убеждена в том, что пока отношения клиента-->
      <!--                        с терапевтом не будут ощущаться как безопасные, не получиться подойти к-->
      <!--                        тому, что лежит глубоко внутри нас, соприкоснуться с болезненным,-->
      <!--                        волнующим. В связи с этим я стараюсь уделять много внимания атмосфере-->
      <!--                        контакта, создавая принимающее, безоценочное, поддерживающее-->
      <!--                        пространство, где вы сможете открыто поделиться со мной вашими-->
      <!--                        переживаниями и попробовать найти пути для изменений.-->
      <!--                      </v-card-text>-->
      <!--                    </div>-->
      <!--                  </v-expand-transition>-->
      <!--                </v-card>-->
      <!--              </v-col>-->

      <!--              <v-col>-->
      <!--                <v-card-->
      <!--                >-->
      <!--                  <v-img-->
      <!--                    src="../../public/pictures/24.jpg"-->
      <!--                    height="400px"-->
      <!--                  ></v-img>-->

      <!--                  <v-card-title>-->
      <!--                    Внимание к чувствам, телесным проявлениям-->
      <!--                  </v-card-title>-->

      <!--                  <v-card-actions>-->
      <!--                    <v-btn-->
      <!--                      color="orange lighten-2"-->
      <!--                      text-->
      <!--                      @click="show2 = !show2"-->

      <!--                    >-->
      <!--                      Подробнее-->
      <!--                    </v-btn>-->

      <!--                    <v-spacer></v-spacer>-->

      <!--                    <v-btn-->
      <!--                      icon-->
      <!--                      @click="show2 = !show2"-->
      <!--                    >-->
      <!--                      <v-icon>{{ show2 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>-->
      <!--                    </v-btn>-->
      <!--                  </v-card-actions>-->

      <!--                  <v-expand-transition>-->
      <!--                    <div v-show="show2">-->
      <!--                      <v-divider></v-divider>-->

      <!--                      <v-card-text>-->
      <!--                        Язык тела – первый способ взаимодействия с миром, которому учится ребенок. То, насколько удачным-->
      <!--                        был опыт ранних телесных контактов, удовлетворения потребностей родителями, оказывает влияние на-->
      <!--                        всю нашу последующую жизнь. <br/>-->
      <!--                        В современном обществе присутствует тенденция отождествлять разум, когнитивную составляющую, и-->
      <!--                        человека. При этом телесные ощущения, эмоции, чувства зачастую отходят на второй план, или-->
      <!--                        совсем игнорируются, а на наше тело мы обращаем внимание только в тех случаях, когда с ним-->
      <!--                        что-то «не так» (болезни, или, например, кажущаясь «внешняя непривлекательность). Часто мы-->
      <!--                        склонны уходить в анализ себя, построение логических объяснений своих действий. В то же время,-->
      <!--                        такой подход не дает нам увидеть себя целиком, во всем богатстве наших проявлений. Но наше тело-->
      <!--                        с его потребностями, симптомами, непонятными ощущениями, чувствами хочет быть услышано. <br/>-->
      <!--                        В своей работе для меня важно учитывать эту часть опыта, вместе с клиентом попробовать с ним-->
      <!--                        соприкоснуться, увидеть новые грани себя. Иногда здесь открывается очень много ресурсов, которые-->
      <!--                        могут поддержать нас на пути к изменениям.-->
      <!--                      </v-card-text>-->
      <!--                    </div>-->
      <!--                  </v-expand-transition>-->
      <!--                </v-card>-->
      <!--              </v-col>-->

      <!--              <v-col>-->
      <!--                <v-card-->
      <!--                >-->
      <!--                  <v-img-->
      <!--                    src="../../public/pictures/25.jpg"-->
      <!--                    height="400px"-->
      <!--                  ></v-img>-->

      <!--                  <v-card-title>-->
      <!--                    Исследовательская позиция-->
      <!--                  </v-card-title>-->

      <!--                  <v-card-actions>-->
      <!--                    <v-btn-->
      <!--                      color="orange lighten-2"-->
      <!--                      text-->
      <!--                      @click="show3 = !show3"-->

      <!--                    >-->
      <!--                      Подробнее-->
      <!--                    </v-btn>-->

      <!--                    <v-spacer></v-spacer>-->

      <!--                    <v-btn-->
      <!--                      icon-->
      <!--                      @click="show3 = !show3"-->
      <!--                    >-->
      <!--                      <v-icon>{{ show3 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>-->
      <!--                    </v-btn>-->
      <!--                  </v-card-actions>-->

      <!--                  <v-expand-transition>-->
      <!--                    <div v-show="show3">-->
      <!--                      <v-divider></v-divider>-->

      <!--                      <v-card-text>-->
      <!--                        Я, как психолог, обладаю некоторыми знаниями, навыками, профессиональными компетенцими, и,-->
      <!--                        используя их, а также свой жизненный опыт, опыт личной терапии, я могу постараться вам помочь-->
      <!--                        изучить себя, лучше понять, чего вы хотите и как можно к этому прийти. <br/>-->
      <!--                        В то же время, для меня клиент сам является автором своей жизни, поэтому я стремлюсь не-->
      <!--                        навязывать Вам свои ценности и мое восприятие мира. Я не знаю заранее, что для вас хорошо, а что-->
      <!--                        плохо, на этот вопрос ответить можете только вы сами. <br/>-->
      <!--                        Подробнее о том, что для меня значит психотерапия, можно почитать-->
      <!--                        <router-link to="/about">здесь</router-link>-->
      <!--                        .-->
      <!--                      </v-card-text>-->
      <!--                    </div>-->
      <!--                  </v-expand-transition>-->
      <!--                </v-card>-->
      <!--              </v-col>-->

      <!--            </v-row>-->


      <!--          </div>-->
      <!--        </div>-->
    </v-row>
  </v-container>
</template>

<script>
import Header from "@/components/Header";

export default {
  name: "Worth",
  components: {
    Header
  }
}
</script>

<style scoped>

</style>